<p-dialog
  header="Create Organization"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [closable]="!submitting()"
  [style]="{ width: '30rem', maxWidth: '95vw' }"
  [(visible)]="visible"
  (onHide)="closeDialog()">
  <form [formGroup]="form" (ngSubmit)="onSubmit()" class="space-y-4">
    @if (errorMessage()) {
      <div class="rounded-lg border border-red-500/20 bg-red-500/10 px-3 py-2 text-xs text-red-500">
        {{ errorMessage() }}
      </div>
    }

    <div class="space-y-1.5">
      <label for="organizationName" class="text-[11px] font-bold text-slate-500 uppercase tracking-wider">
        Organization Name
      </label>
      <input
        id="organizationName"
        pInputText
        formControlName="organizationName"
        placeholder="e.g. Acme Corp"
        class="w-full" />
      @if (form.controls.organizationName.touched && form.controls.organizationName.invalid) {
        <p class="text-xs text-red-500">Please enter an organization name.</p>
      }
    </div>

    <div class="space-y-1.5">
      <label for="workspaceName" class="text-[11px] font-bold text-slate-500 uppercase tracking-wider">
        First Workspace Name
      </label>
      <input
        id="workspaceName"
        pInputText
        formControlName="workspaceName"
        placeholder="e.g. Main Workspace"
        class="w-full" />
      @if (form.controls.workspaceName.touched && form.controls.workspaceName.invalid) {
        <p class="text-xs text-red-500">Please enter a workspace name.</p>
      }
    </div>

    <div class="flex justify-end gap-2 pt-2">
      <button
        pButton
        type="button"
        label="Cancel"
        severity="secondary"
        [outlined]="true"
        [disabled]="submitting()"
        (click)="closeDialog()"></button>
      <button
        pButton
        type="submit"
        label="Create"
        [loading]="submitting()"
        [disabled]="form.invalid || submitting()"></button>
    </div>
  </form>
</p-dialog>
